<script>
	import PageBanner from  "$lib/sections/PageBanner.svelte";
	import Features from  "$lib/sections/Features.svelte";
	import SideBySide from  "$lib/sections/SideBySide.svelte";
	import Form from  "$lib/sections/Form.svelte";

	export let data;

	let lang;
	$: lang = data.lang;

	let area;
	$: area = data.area;

	const col = "scholarships";
</script>

<PageBanner {data} {lang} {area} {col} settingId={"PageBanner"} />

<Features {data} {lang} {area} {col} settingId={"Features 01"} />

<SideBySide {data} {lang} {area} {col} settingId={"SideBySide 01"} />

<SideBySide {data} {lang} {area} {col} settingId={"SideBySide 02"} />

<Features {data} {lang} {area} {col} settingId={"Features 02"} />

<SideBySide {data} {lang} {area} {col} settingId={"SideBySide 03"} />

<Features {data} {lang} {area} {col} settingId={"Features 03"} />

<SideBySide {data} {lang} {area} {col} settingId={"SideBySide 04"} />

<Form {data} {lang} {area} {col} settingId={"Form Apply Now"} />
